/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- NOTIFICATIONS : STYLES --------------- ++++++++++ */
export default  {
  notifications: {
    '& .sectiongroup': {
      width: '65%',
      display: "flex",
      marginTop: 0,
      marginBottom: pxToEm(20),
    },
    '& .switch': {
      marginRight: pxToEm(16)
    },
    '& .text': {
      width: pxToEm(450)
    }
  },
  updateSuccess: {
    color: themeV2.color.success.main
  },
  updateFailed: {
    color: themeV2.color.error.main
  }
};